import { FC } from 'react';
import { ApplicationsDropdownMenuMobile } from '../../../components/ApplicationsDropdownMenu/ApplicationsDropdownMenuMobile';
import { DropdownMobileMenuProps } from '../../../components';
import { ApplicationsDropdownItems } from './ApplicationsDropdownItems';

export const ApplicationsDropdownWrapperMobile: FC<DropdownMobileMenuProps> = ({ trigger, ...rest }) => (
  <ApplicationsDropdownMenuMobile trigger={trigger} {...rest}>
    <ApplicationsDropdownItems />
  </ApplicationsDropdownMenuMobile>
);
